export default __webpack_public_path__ + "static/media/t-shirts.5e9aaa8d.png";